import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import record, { flatten, deepen } from '../../versa/record.js';
import { notify, ask } from '../../versa/msgbox.js';
import view from '../views/payment-terms.js';
import form from '../forms/payment-terms.js';
import * as types from '../types.js';

const payment_terms = function()
{

	let payment_terms_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_payment_terms, query);
		},
		async loadRecord(id)
		{
			let _record = await api.call(api.select_payment_term, ...JSON.parse(id));
			return flatten(_record, 'installments');
		},
		editRecord(data)
		{
			record.edit(this.record_form, this.saveRecordWrapper.bind(this), data);
		},
		async saveRecord(data, old_data)
		{
			data = deepen(data, 'installments');
			let _record = {
				name: data.name,
				installments: data.installments.map(installment => ({ 
					days: Number(installment.days),
					percentage: Number(installment.percentage)
				}))
			};
			if (old_data)
				return await api.call(api.update_payment_term, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_payment_term, data.company_id, _record);
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Saída', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador da condição de pagamento' },
		{ index: 3, field: 'name', label: 'Nome', types: [], placeholder: '', title: 'Nome da condição de pagamento' },
	];

	payment_terms_crud.run(
		'payment_terms',
		'Condições&nbsp;Pagamento',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs
	);

};

export default payment_terms;

